module.exports = __webpack_public_path__ + "operace-previsleho-bricha-abdominoplastika_3_before_tn.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures_tn/plasticka-chirurgie/operace-previsleho-bricha-abdominoplastika_3_before_tn.jpg
// module id = 1666
// module chunks = 0